import { render, staticRenderFns } from "./tokenlogin.vue?vue&type=template&id=27dc2760"
import script from "./tokenlogin.vue?vue&type=script&lang=js"
export * from "./tokenlogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports